
















































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Hospital } from '../store/types';

@Component
export default class extends Vue {
  @Prop({ default: null })
  public hospital!: Hospital;
  @Prop({ default: false })
  public topMatch!: boolean;

  @Prop({ default: true })
  public showDetails!: boolean;

  @Prop({ default: false })
  public showAddress!: boolean;

  private get driveTime() {
    const hospital = this.hospital;
    if (!hospital) {
      return '';
    }
    if (
      !hospital.travel_information ||
      hospital.travel_information.travel_time < 0
    ) {
      return '';
    }
    const hours = Math.floor(hospital.travel_information.travel_time / 60 / 60);
    const minutes =
      Math.floor(hospital.travel_information.travel_time / 60) - hours * 60;
    return hours ? `${hours} hours` : `${minutes} mins`;
  }
  private get waitTime() {
    const hospital = this.hospital;
    // if (!hospital.current_wait_time || hospital.current_wait_time < 0) {
    //   return "?";
    // }
    // const hours = Math.floor(hospital.current_wait_time / 60 / 60);
    // const minutes = Math.floor(hospital.current_wait_time / 60) - hours * 60;
    // return hours ? `${hours}h` : `${minutes}m`;
    return '?';
  }

  @Emit('click')
  private onClick(event: Event) {
    return event;
  }
}
